/* eslint-disable @tencent/i18next/no-literal-string */
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { transaction } from '@src/slide/domain/slide-app';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import _get from 'lodash/get';
import _extend from 'lodash/extend';
import i18n from '@i18next/i18n';
import { ShapeMenuItems } from '@src/framework/editor/src/js/constants/shape-default-data';
import { STShapeType } from '@tencent/slide-sdk-model';

export {
    transaction,
};

export function getPlatformShortcut(shortcut) {
    if (shortcut) {
        if (!browser.isMac) {
            // eslint-disable-next-line no-param-reassign
            shortcut = shortcut.replace(/Cmd|⌘/i, 'Ctrl');
            shortcut = shortcut.replace(/Option|⌥/i, 'Alt');
        } else {
            // eslint-disable-next-line no-param-reassign
            shortcut = shortcut.replace(/Cmd/i, '⌘');
            shortcut = shortcut.replace(/Option/i, '⌥');
        }
    }
    return shortcut;
}

export function dispatchCustomEvent(eventName, element, data = {}) {
    let event;
    if (document.createEvent) {
        event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, true, true);
    } else {
        event = (document as any).createEventObject();
        event.eventType = eventName;
    }
    event = _extend(event, { eventName }, data);
    return (document as any).createEvent ? element.dispatchEvent(event) : element.fireEvent(`on${event.eventType}`, event);
}

/* eslint-disable @tencent/i18next/no-literal-string */
/**
 * 获取元素展示名称
 * @param {*} elementModel 元素
 * @param {*} showTextRun 是否展示文本内容
 * @param {*} showId 是否展示id
 * @returns
 */
export const getElementDisplayName = (elementModel, showTextRun = true, showId = false) => {
    const getDisplayName = (type) => {
        let shapeName = elementModel.sdkData.name;
        // 本地导入的shape有name，在线创建的无name
        // 为了避免本地导入shape展示问题，如：椭圆 12 12
        // 只允许在线创建的shape开启showId
        if (!shapeName) {
            shapeName = i18n.t(type);
            if (showId) shapeName += ` ${elementModel.id}`;
        }
        if (showTextRun && getShapeTextRun(elementModel)) shapeName += `: ${getShapeTextRun(elementModel)}`;
        return shapeName;
    };
    const getTextOrConnectName = () => {
        if (elementModel.isText) {
            return getDisplayName('文本框');
        }
        if (elementModel.isPlaceholder) {
            return getDisplayName('占位符');
        }
        const prstGeom = elementModel.sdkData?.props?.prstGeom?.prstGeomType;
        if (prstGeom) {
            return getDisplayName(getShapeNameByPrstGeom(prstGeom));
        }
        return getDisplayName('自定义图形');
    };
    const typeToNameMap = {
        [UIModelType.SHAPE]: () => getTextOrConnectName(),
        [UIModelType.CONNECTOR]: () => getTextOrConnectName(),
        [UIModelType.IMAGE]: () => getDisplayName('图片'),
        [UIModelType.TABLE]: () => getDisplayName('表格'),
        [UIModelType.GROUP]: () => getDisplayName('组合'),
    };
    return _get(typeToNameMap, elementModel.type, () => {})();
};
/* eslint-enable @tencent/i18next/no-literal-string */

/**
 * 获取元素对应文本内容
 */
export const getShapeTextRun = (shapeModel) => {
    if (!shapeModel.paragraphList) return '';
    let content = '';
    shapeModel.paragraphList.forEach((para) => {
        if (para.textRuns && para.textRuns.length > 0) {
            content = `${content} ${para.textRuns.reduce((res, curText) => res + curText.text, '')}`;
        }
    });
    return content.trim();
};

/**
 * 获取几何图形对应的汉化名字
 * @param {*} prstGeom
 * @returns
 */
export const getShapeNameByPrstGeom = (prstGeom) => {
    for (let i = 0; i < ShapeMenuItems.length; i++) {
        for (let j = 0; j < ShapeMenuItems[i].groupvalue.length; j++) {
            if (ShapeMenuItems[i].groupvalue[j].type === STShapeType[prstGeom]) {
                return ShapeMenuItems[i].groupvalue[j].title;
            }
        }
    }
    return STShapeType[prstGeom];
};

/**
 * 判断两个对象是一样的
 * @param a
 * @param b
 * @returns {boolean}
 */
// eslint-disable-next-line complexity
export function isSameObj(a, b) {
    const keysA = Object.keys(a || {});
    const keysB = Object.keys(b || {});
    if (keysA.length !== keysB.length) {
        return false;
    }
    if (a && b) {
        for (const key of keysA) {
            if (!keysB.includes(key)) {
                return false;
            }
            if (a[key] !== b[key]) {
                if (typeof a[key] === 'object' && a[key] && b[key]) {
                    return isSameObj(a[key], b[key]);
                }
                return false;
            }
        }
    }
    return true;
}
